import { BFFWebChatContextProvider } from '@sa/bff-webchat-ui';
import React from 'react';
import CassiusWebChat from './CassiusWebChat';
import { bffStyleOptions } from './customStyles';

const App = () => (
  <BFFWebChatContextProvider styleOptions={bffStyleOptions}>
    <CassiusWebChat />
  </BFFWebChatContextProvider>
);

export default App;
